/* svnty-cart-bus.js - THE CART BUS (D6-7, R200, 2026-09-25 19:22 and 19:27). Classic, deferred, no deps, ES5, ASCII.
 *
 * ONE truth for "how many of THIS piece are in the bag", so every card's bag (THE COUNTED ICON in its bound mode,
 * assets/svnty-quickadd.js) and the header's bag move together. window.SVNTY.cart holds the cart's lines from /cart.js
 * (variant, product, quantity, the variant's options), fetched once after DOMContentLoaded and again after every writer:
 * the theme's bus (PUB_SUB_EVENTS.cartUpdate: the PDP's add, the cart drawer's and the cart page's quantity changes, the
 * one add path's announce), the DOM roads (cart:update, svnty:cart:added, shopify:cart:lines-update) and a bfcache
 * restore. A refresh is debounced 150 ms, one request in flight; a write that lands while a request is out makes that
 * answer stale, so it is dropped and asked again. No polling.
 * An add's answer (THE ONE ADD PATH, the PDP's form, the door; all announce on the theme's bus) is the line as it now
 * stands, so it is applied at once, in the same task that repaints the header's bubble, then the refresh reconciles.
 * A write that carries the whole cart (cart.js's /cart/change answer) is applied as it is. window.SVNTYCartAdd is
 * wrapped only so a refused add still asks /cart.js.
 * Every change of the lines dispatches `svnty:cart` on document with { lines, count, quiet }: quiet is true for the
 * seed and the boot fetch (a page load never animates a count; only a real change does); a refresh that finds no
 * change dispatches nothing. The lines are kept in
 * sessionStorage so a page's cards paint at once from the tab's last answer (as the header's counted icon does).
 */
(function () {
  'use strict';
  var SV = window.SVNTY = window.SVNTY || {};
  if (SV.cart) return;
  var lines = [], count = 0, sig = null, gen = 0, timer = 0, inflight = false, again = false, KEY = 'svnty:cart-lines';

  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function norm(it) {
    return {
      variant_id: Number(it.variant_id || it.id) || 0,
      product_id: Number(it.product_id) || 0,
      quantity: Number(it.quantity) || 0,
      options: it.variant_options || (it.options_with_values || []).map(function (o) { return o && o.value; })
    };
  }
  function emit(quiet) {
    var s = lines.map(function (l) { return l.variant_id + ':' + l.quantity; }).join(',');
    if (s === sig) return;
    sig = s;
    try { sessionStorage.setItem(KEY, JSON.stringify({ l: lines, c: count })); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('svnty:cart', { detail: { lines: lines.slice(), count: count, quiet: !!quiet } })); } catch (e) {}
  }
  function applyCart(cart, quiet) {
    if (!cart || !Array.isArray(cart.items)) return false;
    lines = cart.items.map(norm).filter(function (l) { return l.quantity > 0; });
    count = typeof cart.item_count === 'number' ? cart.item_count : lines.reduce(function (a, l) { return a + l.quantity; }, 0);
    emit(quiet);
    return true;
  }
  /* P28 lane E (launch audit cart P2-6): a refused read (429, 5xx) or a dropped line is asked again, twice at most (Retry-After,
     else 1.5 s then 3 s), so the cards' counts never stay on an optimistic guess after a busy minute; the read is idempotent */
  var fails = 0;
  function fetchNow(quiet) {
    if (inflight) { again = true; return; }
    inflight = true;
    var at = gen, wait = 0;
    fetch(root() + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) {
        if (!r.ok) { var after = parseFloat(r.headers.get('Retry-After')); if (after > 0) wait = Math.min(after * 1000, 4000); throw new Error('cart ' + r.status); }
        return r.json();
      })
      .then(function (cart) { fails = 0; if (at === gen) applyCart(cart, quiet === true); else again = true; })
      .catch(function () {
        if (fails < 2) { fails += 1; var q = quiet; setTimeout(function () { fetchNow(q); }, wait || 1500 * fails); }
        else fails = 0;
      })
      .then(function () { inflight = false; if (again) { again = false; refresh(); } });
  }
  function refresh() { clearTimeout(timer); timer = setTimeout(fetchNow, 150); }
  /* a known add: /cart/add answers with the line as it now stands (its quantity is the line's TOTAL, measured: the
     same size added twice answered 1, then 2), so the held line takes that quantity now; /cart.js is the judge */
  function setLine(item) {
    var l = norm(item), have = null;
    if (!l.variant_id || !l.product_id) return false;
    for (var i = 0; i < lines.length; i++) if (lines[i].variant_id === l.variant_id) { have = lines[i]; break; }
    gen++;
    lines = lines.slice();
    if (have) { count += l.quantity - have.quantity; have.quantity = l.quantity; } else { lines.push(l); count += l.quantity; }
    emit();
    refresh();
    return true;
  }
  /* how many of one product, in one colour (the colour option's 1-based position; 0 = every line of the product) */
  function qty(productId, pos, colour) {
    var pid = Number(productId) || 0, n = 0;
    if (!pid) return 0;
    for (var i = 0; i < lines.length; i++) {
      var l = lines[i];
      if (l.product_id !== pid) continue;
      if (pos > 0 && colour && String((l.options || [])[pos - 1] || '') !== String(colour)) continue;
      n += l.quantity;
    }
    return n;
  }
  SV.cart = {
    get lines() { return lines.slice(); },
    get count() { return count; },
    get ready() { return sig !== null; },
    qty: qty,
    refresh: refresh,
    set: setLine
  };

  /* THE ONE ADD PATH, wrapped once (it is defined by svnty-cart-toast.js, loaded before this file) */
  function wrapAdd() {
    var f = window.SVNTYCartAdd;
    if (typeof f !== 'function' || f.__svntyBus) return;
    var w = function () {
      /* the success is applied on its announce (onWrite, the same task as the header's repaint); a refusal still asks */
      return f.apply(this, arguments).then(function (res) { if (!(res && res.ok)) refresh(); return res; });
    };
    w.__svntyBus = true;
    window.SVNTYCartAdd = w;
  }
  wrapAdd();

  function onWrite(ev) {
    var d = ev && (ev.cartData || (ev.detail && (ev.detail.cartData || ev.detail.resource)));
    /* an add's answer (THE ONE ADD PATH, the PDP's form, the door): the line as it now stands */
    if (d && !d.status && !Array.isArray(d.items) && d.product_id && typeof d.quantity === 'number') { setLine(d); return; }
    /* P27-3 (audit P1-6): the write carried the whole cart; asking /cart.js again only fed the store's rate limit */
    if (d && Array.isArray(d.items) && typeof d.item_count === 'number') { gen++; applyCart(d); return; }
    refresh();
  }
  function bindPubSub() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS !== 'object' || !PUB_SUB_EVENTS.cartUpdate) return false;
    try { subscribe(PUB_SUB_EVENTS.cartUpdate, onWrite); } catch (e) { return false; }
    return true;
  }
  /* the first paint: the lines this tab last saw (the cards paint with the header's own first paint, which comes from
     sessionStorage too); the fetch at boot is the judge */
  try { var seed = JSON.parse(sessionStorage.getItem(KEY) || 'null'); if (seed && Array.isArray(seed.l)) { lines = seed.l; count = seed.c | 0; emit(true); } } catch (e) {}
  var bound = bindPubSub();
  document.addEventListener('cart:update', onWrite);
  document.addEventListener('svnty:cart:added', refresh);
  document.addEventListener('shopify:cart:lines-update', refresh);
  /* a bfcache restore is a page load: its answer paints still (D6-11) */
  window.addEventListener('pageshow', function (e) { if (e.persisted) { gen++; fetchNow(true); } });
  function boot() { if (!bound) bound = bindPubSub(); wrapAdd(); fetchNow(true); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true }); else boot();
})();
